import React from 'react';
import { Table, Tag } from 'antd';
import { InboundShipment } from '../../../services/supplyChainService';

interface LogisticsShipmentTableProps {
    dataSource: InboundShipment[];
    loading: boolean;
}

export const LogisticsShipmentTable: React.FC<LogisticsShipmentTableProps> = ({ dataSource, loading }) => {
    const columns = [
        { title: 'Shipment ID', dataIndex: 'shipment_id', key: 'shipment_id' },
        { title: 'Shop', dataIndex: 'shop_name', key: 'shop_name' },
        { title: 'Batch', dataIndex: 'batch_number', key: 'batch_number' },
        { title: 'Status', dataIndex: 'shipment_status', key: 'status', render: (s: string) => <Tag>{s}</Tag> },
    ];

    return <Table dataSource={dataSource} columns={columns} rowKey="id" loading={loading} />;
};
